module.exports = __webpack_public_path__ + "static/media/mario-world-clear.7cc15b3d.mp3";